import { bindUrl, request } from "./request";
/**
 * 框架协议模板
 */
export function templateDetail(queryParams) {
  return request({
    url: bindUrl("/oil/app/client/template/detail", {}),
    method: "GET",
    params: queryParams
  });
}

/**
 * 签名参数生成
 */
export function buildSignAction(bodyParams) {
  return request({
    url: bindUrl("/oil/app/client/sign/buildSignAction", {}),
    method: "POST",
    data: bodyParams
  });
}

/**
 * 签名生成上传
 */
export function signUpload(bodyParams) {
  return request({
    url: bindUrl("/oil/app/client/sign/upload", {}),
    method: "POST",
    data: bodyParams
  });
}
